
class History {

    constructor(history){
        this.history = history;
    }

    goHome(){
        this.history.push('/');
    }

    goProfile(){
        this.history.push('/profile');
    }

    goOrders(){
        this.history.push('/Orders');
    }
    goBill(){
        this.history.push('/Bill');
    }

    goItems(){
        this.history.push('/items');
    }

    goBackOrder(){
        this.history.push('/backOrder');
    }

    goShoppingCart(){
        this.history.push('/shoppingCart');
    }

    goAboutUs(){
        this.history.push('/aboutUs');
    }

    goContactUs(){
        this.history.push('/contactUs');
    }

    goSelectClient(){
        this.history.push('/selector');
    }
    goReports(){
        this.history.push('/reports');
    }

    goSelectAddress(){
        this.history.push('/selectAddress');
    }

    goValidateOrder(){
        this.history.push('/validateOrder');
    }

    goCreateOrder(){
        this.history.push('/createOrder');
    }

    goSelector(){
        this.history.push('/selector');
    }

    goPromocionales(){
        this.history.push('/promocionales');
    }

    goMyProfile(){
        this.history.push('/myprofile')
    }

    goSubirArchivo(){
        this.history.push('/subirArchivo')
    }

    goAutorizaciones(){
        this.history.push('/autorizaciones')
    }
    goRegistroPedidos(){
        this.history.push('/registroPedidos')
    }

    goCanalModerno(){
        this.history.push('/canalModerno')
    }

    goCartsSaved(){
        this.history.push('/cartsSaved')
    }

    goOrderStatus(){
        this.history.push('/orderStatus')
    }

    goDocumentsCreatedCM(){
        this.history.push('/DocumentsCreatedCM')
    }
    
    goMyProfileSeller(){
        this.history.push('/myprofileSeller')
    }

    goAutoGestCartsSaved(){
        this.history.push('/autoGestCarts')
    }
}

export default History;